import createClient from "openapi-fetch";
import { paths } from "./schema";
import { createAuthMiddleware } from "./authMiddleware";
import { ApiAuth } from "./auth";

export const client = createClient<paths>();

export type ApiClient = typeof client;

export function createAuthenticatedClient(auth: ApiAuth): ApiClient {
  const client = createClient<paths>();

  client.use(createAuthMiddleware(auth));
  return client;
}
